import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";
import { IUseDeleteOfferMutationResponse } from "../utils/types";

const useDeleteOurStory = (): IUseDeleteOfferMutationResponse =>
  useMutation({
    mutationFn: async (data: any) => {
      const response = await AXIOS_RESERVATION.delete(`/delete-our-story/${data.id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["our-story"] });
    },
  });

export default useDeleteOurStory;
